import * as React from "react";
import { Button } from "nvs-design-system/dist/Button_DEPRECATED";
import {
  ButtonProps,
  ButtonSize,
} from "nvs-design-system/dist/Button_DEPRECATED/types";
import clsx from "clsx";

type TokenTransferStepButtonProps = {
  children: React.ReactNode;
} & ButtonProps;

const TokenTransferStepButton: React.FC<TokenTransferStepButtonProps> = ({
  onClick,
  children,
  className,
  ...props
}) => {
  return (
    <Button
      {...props}
      onClick={onClick}
      size={ButtonSize.sm}
      className={clsx(
        className,
        "rounded-md py-4 capitalize !justify-center w-full",
      )}
    >
      {children}
    </Button>
  );
};

export default TokenTransferStepButton;
